import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { GourmetTransactionsQueryVariables } from '@/gql/graphql';

export const fetchGourmetTransactions = async ({ phoneNumber, pagination }: GourmetTransactionsQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query GourmetTransactions($phoneNumber: String, $pagination: PaginationInputType) {
        gourmetTransactions(phoneNumber: $phoneNumber, pagination: $pagination) {
          count
          rows {
            id
            date
            category
            description
            notes
            currency
            amount
            associatedObjectType
            associatedObjectId
            createdAt
            updatedAt
            status
            errorCode
            ipAddress
            ipCountry
            device
            operatingSystem
            browser
            user {
              firstName
              lastName
              role
            }
            distributions {
              transactionId
              sortOrder
              class
              account
              amount
              associatedObjectType
              associatedObjectId
              stripeCustomerId
              stripeChargeId
              stripeRefundId
              createdAt
              status
            }
          }
        }
      }
    `),
    variables: {
      phoneNumber,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.gourmetTransactions;
};
